var service = 'http://api2.dev.qnbar.cn/';
var api = {
    login: service + "zyu/oss/admin/login", //登录
    addstoreinfo: service + "bz-oss/oss/mix-agent/create-agent", //增加门店 
    editstoreinfo: service + "bz-oss/oss/mix-agent/update-agent", //编辑门店
    getstorelist: service + "bz-oss/oss/mix-agent/get-list", //门店列表信息
    changepass: service + "bz-oss/oss/change/pwd", //oss修改密码
    getprovincelist: service + "common/oss/region/get-province", //省份列表
    getcitylist: service + "common/oss/region/get-city", //市区列表 
}
export default {
    api: api
}


// WEBPACK FOOTER //
// ./src/base.js